import { createSlice } from "@reduxjs/toolkit";

const initialnewAdscompanylistSlice = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  contestData: [],
  contestUsers: [],
  retentionreportlist: [],
  gameList: [],
  ruless: {},
  gameTypeList: [],
  company: [],
  currency: [],
  upload: {},
  imageField: undefined,
  screenShots: [],
  screenshot: [],
  totalJoinedPlayers: 0,
  companyListstatus: []
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const NewAdscompanylistSlice = createSlice({
  name: "newAdscompanylistSlice",
  initialState: initialnewAdscompanylistSlice,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    contestListList: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("totalCount, entities slice", totalCount, entities);
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    contestDetails: (state, action) => {
      const { contestData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestData = contestData;
      console.log(contestData);
    },

    contestUsersList: (state, action) => {
      const { contestUsers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestUsers = contestUsers;
    },
    gameList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameList = entities;
    },
    gameTypeList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameTypeList = entities;
    },
    company: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.company = entities;
      // state.totalCount = totalCount;
    },
    currency: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.currency = entities;
      // state.totalCount = totalCount;
    },
    // itemUpdated: (state, action) => {
    //   state.error = null;
    //   state.actionsLoading = false;
    //   state.entities = [];
    // },
    imageUploaded: (state, action) => {
      const { entities, imageField } = action.payload;
      // console.log('in e',entities)
      // console.log('in f',imageField)

      state.error = null;
      state.upload = entities;
      state.imageField = imageField;
    },
    saveScreenShot: (state, action) => {
      const { screenShots } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.screenShots = screenShots;
    },
    saveIsHackingProof: (state, action) => {
      const { isHackingProofImages } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.isHackingProofImages = isHackingProofImages;
    },
    saveTotalJoinedPlayers: (state, action) => {
      const { totalJoinedPlayers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalJoinedPlayers = totalJoinedPlayers;
    },
    // singleItemFetched: (state, action) => {
    //   state.actionsLoading = false;
    //   state.ruless = action.payload.ruless;
    //   state.error = null;
    // },

    singleItemFetchedScreenshot: (state, action) => {
      const { screenshot } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.screenshot = screenshot;
      console.log(screenshot);
    },
    CountryList: (state, action) => {
      const { countryList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryList = countryList;
    },

    CountryDropdownList: (state, action) => {
      const { countryDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryDropdownList = countryDropdownList;
    },
    singleItemFetched: (state, action) => {
      console.log(action.payload.coinStoresForEdit, "------------");
      state.actionsLoading = false;
      state.coinStoresForEdit = action.payload.coinStoresForEdit;
      state.error = null;
    },
    listFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // itemCreated
    itemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.entities.push(action.payload.item);
      state.entities = [];
    },
    // itemUpdated
    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.item._id) {
      //     return action.payload.item;
      //   }
      //   return entity;
      // });
      state.entities = [];
    },
    CompanyListstatus: (state, action) => {
      const { companyListstatus } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.companyListstatus = companyListstatus;
    },

  },
});
